import {type MouseEvent} from 'react'
import classNames from 'classnames'
import styled from 'styled-components'

const StyledResizeHandle = styled.div`
  position: absolute;
  top: 0;
  right: -3px;
  bottom: 0;
  width: 0.75rem;
  background: transparent;
  z-index: 1;
  cursor: col-resize;

  &::after {
    content: '';
    position: absolute;
    top: 25%;
    bottom: 25%;
    right: 3px;
    width: 1px;
    background: rgba(255, 255, 255, 0.6);
    transition: background 0.2s;
  }

  &:hover,
  &.active-resizing {
    &::after {
      background: rgba(255, 255, 255, 0.9);
    }
  }
`

/**
 * Interfaces
 */

interface ResizeHandleProps {
  isResizing: boolean
  onMouseDown: (e: MouseEvent<HTMLDivElement>) => void
  className?: string
}

/**
 * Components
 */

export const ResizeHandle = ({
  isResizing,
  onMouseDown,
  className,
}: ResizeHandleProps) => {
  return (
    <StyledResizeHandle
      data-cy="table-column-resize-handle"
      className={classNames(
        'group-hover:visible',
        {
          visible: isResizing,
          invisible: !isResizing,
        },
        className,
      )}
      onMouseDown={event => onMouseDown(event)}
    />
  )
}
